module.exports = __webpack_public_path__ + "static/img/23.450bc0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka3/23.jpg
// module id = Y1q2
// module chunks = 16